// NOTE: Dependencies: jQuery

(function ($) {
	// Compare heights function
	$.fn.setAllToMaxHeight = function() {
		return this.outerHeight(Math.max.apply(this, $.map(this, function(e) {
			return $(e).outerHeight();
		})));
	};

	// Set heights
	$.fn.lmEqualHeights = function(options) {
		// check is dom element is defined 
		if (!this.length) {
			return false;
		}

		// Default settings are set here.
		var settings = $.extend({
			selectors: ['.article-list__title', '.article-list__header'],
			$wrapper: $('.article-card'),
			$tabWrapper: $('.tab-nav__item')
		}, options);

		// These are all the methods available for the plugin.
		var	methods = {},
			timer,
			selectorCounter = 0;

		methods.setCurrentSettings = function($context) {
			var currentSettings = $context.data();

			if (!$.isEmptyObject(currentSettings)) {	
				$context.data($.extend({}, settings, currentSettings));
			} else {
				$context.data(settings);
			}

			// Initialize item.
			$context.data('initialized', true);
		}

		methods.equalHeights = function() {
			// Reset the counter variable.
			selectorCounter = 0;

			// Loop through the selector array.
			while (selectorCounter < settings.selectors.length) {
				// Loop through each item.
				settings.$wrapper.each(function () {
					// Compare and set heights.
					$(this).find(settings.selectors[selectorCounter]).not('.article-list--twin .article-list__title').setAllToMaxHeight();
				});
				// Increment the counter variable.
				selectorCounter++;
			}
		}

		// Remove all of the style attributes created by the plugin.
		methods.resetHeights = function() {
			// Reset the counter variable.
			selectorCounter = 0;

			// Loop through the selector array.
			while (selectorCounter < settings.selectors.length) {
				// Loop through each item.
				settings.$wrapper.each(function () {
					// Loop through and remove the style attributes.
					$(this).find(settings.selectors[selectorCounter]).each(function () {
						$(this).removeAttr('style');
					});

				});
				// Increment the counter variable.
				selectorCounter++;
			}

			// Run the equal heights function after the reset.
			methods.equalHeights();
		}

		// On load function
		methods.initContext = function($context) {
			methods.setCurrentSettings($context);

			setTimeout(function () {
				// Run comparison after a short delay.
				methods.equalHeights($context);
			}, 500);

			// Run comparison on throttled window resize after a short delay.
			$(window).on('resize', function() {
				clearTimeout(timer);
				timer = setTimeout(function () {
					methods.resetHeights($context);
				}, 500);
			});

			// If js tabs exist, reset on tab change just incase the equal heights content is inside.
			if(settings.$tabWrapper.length) {
				settings.$tabWrapper.on('click', function() {
					methods.resetHeights($context);
				});
			}
		}

		// Filter each function.
		methods.filterEach = function() {
			return !$(this).data("initialized");
		}

		// Methods to run inside loop.
		return this.filter(methods.filterEach).each(function() {
			var $this = $(this);

			// NOTE: Method you'd like initialized on a per context basis.
			methods.initContext($this);
		});
	};
}(jQuery));